import React from 'react';

/*eslint-disable */

var calendarIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    width: "20px",
    height: "20px",
    focusable: "false",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.4",
    y: "2.5",
    width: "19.2",
    height: "2.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.4",
    y: "7.5",
    width: "19.2",
    height: "2.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.4",
    y: "17.5",
    width: "19.2",
    height: "2.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "17.6",
    y: "2.5",
    width: "2.4",
    height: "17.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 20 1.17566093e-15 2.5 2.4 2.5 2.4 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(5.200000, 1.250000) rotate(-90.000000) translate(-5.200000, -1.250000) ",
    points: "3.95 0.05 6.45 0.05 6.45 2.45 3.95 2.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(14.800000, 1.250000) rotate(-90.000000) translate(-14.800000, -1.250000) ",
    points: "13.55 0.05 16.05 0.05 16.05 2.45 13.55 2.45"
  })));
});

export default calendarIcon;
